import { AsYouType } from "libphonenumber-js";

/**
 * Formats a phone number string using llibphonenumber-js.
 * Defaults to UK context ('GB').
 * @param {string} value 
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (value) => {
  if (!value) return "";
  const formatter = new AsYouType("GB");
  return formatter.input(value);
};
